const debounce = (callback, delay) => {
	let tid;
	return function (...args) {
		const ctx = this;
		tid && clearTimeout(tid);
		tid = setTimeout(() => {
			callback.apply(ctx, args);
		}, delay);
	};
};

if (typeof window !== "undefined") {
	const _ = window.ResizeObserver;
	window.ResizeObserver = class ResizeObserver extends _ {
		constructor(callback) {
			callback = debounce(callback, 20);
			super(callback);
		}
	};
}

export default {};
